import { useRef, useMemo } from 'react';

let globalIdCounter = 0;

function generateUniqueId() {
    globalIdCounter += 1;
    return globalIdCounter;
}

/**
 * Ein vereinfachter useId-Hook, der immer ein eindeutiges ID-Label generiert.
 * Beachte, dass die tatsächliche Implementierung in React 18
 * zusätzliche Logik für SSR und Hydration enthält.
 */
export function useId(prefix: string = 'id'): string {
    // useRef sorgt dafür, dass die ID über die Lebensdauer der Komponente konstant bleibt.
    const idRef = useRef<string>('');
    if (!idRef.current) {
        idRef.current = `${prefix}-${generateUniqueId()}`;
    }
    return idRef.current;
}
